import './App.css';
import './overwrites.css';

import { Outlet } from '@tanstack/react-router';
import Favicon from 'react-favicon';

import { useBreadcrumbs } from '@/common/hook/useBreadcrumbs';
import { useTheming } from '@/common/hook/useTheming';

const App = () => {
  const data = useTheming();
  const breadcrumbs = useBreadcrumbs();

  if (!data) {
    return null;
  }

  const breadcrumbsString = breadcrumbs
    .map((breadcrumb) => breadcrumb.title)
    .join(' • ');

  return (
    <>
      <Favicon url={data.favicon} />

      <title>{breadcrumbsString || data.applicationName}</title>

      <div className={'min-h-screen w-full'}>
        <Outlet />
      </div>
    </>
  );
};

export default App;
